import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { Button } from "../../../pages/helpCenter";
import { Modal } from "./modal";
import { ICONS } from "../../../utils/Utils";

export const SubcategoryModal = ({ open, initial, categories, defaultCategoryId, onClose, onSave }) => {
  const { register, handleSubmit, watch, control, reset } = useForm({
    defaultValues: { name: "", description: "", categoryId: "", icon: "" },
  });

  useEffect(() => {
    if (open) {
      reset({
        name: initial?.name || "",
        description: initial?.description || "",
        icon: initial?.icon || "",
        categoryId: initial?.categoryId || defaultCategoryId || categories[0]?.id || "",
      });
    }
  }, [open, initial, defaultCategoryId, categories, reset]);

  const name = watch("name");
  const categoryId = watch("categoryId");
  const canSave = name.trim().length > 0 && categoryId;

  const onSubmit = (data) => {
    onSave({ name: data.name.trim(), description: data.description.trim(), categoryId: data.categoryId, icon: data.icon });
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={initial ? "Edit subcategory" : "New subcategory"}
      subtitle="Subcategories group related articles inside a category."
      footer={
        <>
          <Button variant="secondary" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button size="sm" disabled={!canSave} onClick={handleSubmit(onSubmit)}>
            {initial ? "Save changes" : "Create subcategory"}
          </Button>
        </>
      }
    >
      <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
        <label className="block">
          <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500">
            Parent category <span className="text-rose-500">*</span>
          </span>
          <select
            className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-cyan-600"
            {...register("categoryId")}
          >
            {categories.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </select>
        </label>

        <label className="block">
          <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500">
            Name <span className="text-rose-500">*</span>
          </span>
          <input
            className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-cyan-600"
            autoFocus
            placeholder="e.g. Account Setup"
            {...register("name")}
          />
        </label>
        <label className="block">
          <span className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-500">
            Icon
          </span>
          <Controller
            name="icon"
            control={control}
            render={({ field }) => (
              <select
                {...field}
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm"
              >
                <option value="">Select an icon</option>

                {Object.entries(ICONS).map(([key, icon]) => (
                  <option key={key} value={key}>
                    {icon} {key}
                  </option>
                ))}
              </select>
            )}
          />
        </label>

        <label className="block">
          <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500">
            Description
          </span>
          <textarea
            className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:border-cyan-600 resize-none"
            rows={3}
            placeholder="What does this subcategory cover?"
            {...register("description")}
          />
        </label>
      </form>
    </Modal>
  );
};